import * as Yup from "yup";
import { Maybe, Verification } from "../../generated/graphql";
import { getInitialValues } from "../../services/config";

const getSchema = () => {
    return Yup.object().shape({
        name: Yup.string().required().default(""),
    })
}

export default function verificationFormInit(record?: Maybe<Verification>) {
    const schema = getSchema()
    const initial = record ? record : getInitialValues(schema)
    return { schema, initial }
}
